import { string, object } from "yup";

const forgotSchema = object().shape({
  identifiant: string().required("L'identifiant est obligatoire"),
});

export default forgotSchema;